/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PasskeyDeviceInfo } from './passkey-device-info';


export interface PasskeyStatusResponse { 
    /**
     * Indica se l\'utente ha almeno una passkey valida
     */
    has_passkey: boolean;
    /**
     * Lista dei dispositivi con passkey registrate
     */
    devices: Array<PasskeyDeviceInfo>;
    /**
     * Data di scadenza della passkey più vicina alla scadenza
     */
    nearest_expiry?: string;
}

